import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NavigationComponent } from './navigation.component';
import { RouterModule } from '@angular/router';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [NavigationComponent],
  imports: [CommonModule, RouterModule, NgbCollapseModule],
  exports: [NavigationComponent]
})
export class NavigationModule {}
